import React from "react";

const ShowFile = ({
  link,
  label,
  children,
  className,
  target = "_blank",
  width,
  originFile,
}) => {
  console.log(link);
  const token = localStorage.getItem("token");
  // const handleClick = async () => {
  //     const res = await getDataV2(link)
  //     if (res?.data?.status) window.open(res?.data?.data, "_blank")
  // }
  //
  // if (link && link.includes(process.env.REACT_APP_MEDIA)) return <a onClick={handleClick}>{children || label}</a>

  return (
    <a
      target={target}
      href={
        link && link.includes("https://media.s-tech.info")
          ? `${link}?token=${token}`
          : typeof originFile === "object"
          ? URL.createObjectURL(originFile)
          : originFile
      }
      className={className}
      rel="noopener noreferrer"
      style={{ cursor: "pointer" }}
    >
      <div className={`show ${width}`}>{children || label}</div>
    </a>
  );
};

export default ShowFile;
